<template>
  <el-form
    ref="form"
    v-loading="pending"
    accept-charset="UTF-8"
    class="login-form"
    el-loading-background="fixed-white"
    :el-loading-opacity=".8"
    :el-loading-size="48"
    :el-loading-text="$t('Signing in...')"
    errors-in-holder
    method="post"
    :model="user"
    role="form"
    :rules="rules"
    @keyup.enter.native="submit"
  >
    <h2 class="login-form__header">
      {{ $t('Sign in') }}
    </h2>

    <slot />

    <el-form-item
      :error="errors.username"
      prop="username"
    >
      <el-input
        v-model="user.username"
        auto-complete="username"
        data-testid="username"
        :autofocus="!!domainName"
        :label="$t('Login')"
        name="username"
        required
        spellcheck="false"
        @input="clearErrors"
      />
    </el-form-item>

    <el-form-item
      :error="errors.password"
      prop="password"
    >
      <el-password
        v-model="user.password"
        auto-complete="current-password"
        :label="$t('Password')"
        name="password"
        required
        with-icon
        :spellcheck="false"
        @input="clearErrors"
      />
    </el-form-item>

    <div
      v-if="errors.backend"
      class="server-errors mb-24"
      data-testid="server-error"
    >
      {{ errors.backend }}
    </div>

    <el-button
      fluid
      name="login"
      size="large"
      type="primary"
      @click="submit"
    >
      {{ $t('Sign in') }}
    </el-button>
    <id-p-login
      :domain-name="domainName"
      :session-id="sessionId"
    />
  </el-form>
</template>
<script>
  import IdPLogin from '@/common/components/user/IdPLogin.vue';

  export default {
    name: 'LoginForm',
    components: { IdPLogin },
    props: {
      user: Object,
      rules: Object,
      errors: Object,
      pending: Boolean,
      domainName: String,
      sessionId: String // 0 - Admin panel. 1 - SS
    },
    methods: {
      submit() {
        this.$emit('submit');
      },
      clearErrors() {
        this.$emit('clearErrors');
      },
      validate(...args) {
        return this.$refs.form.validate(...args);
      }
    }
  };
</script>
<style lang="scss" scoped>
  .login-form {
    width: 512px;
    padding: 24px 24px 32px;
    margin: 0 auto;
    border-radius: 5px;
    background: $av-inversed-primary;
    position: relative;

    &__header {
      font-size: $av-font-size-l;
      font-weight: $av-font-weight-normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: normal;
      text-align: center;
      color: $av-fixed-primary;
      margin: 0 0 24px;
    }

    .server-errors {
      padding: 24px;
      background: $av-fixed-danger-accent;
      border-radius: $av-border-radius-2;
      text-align: center;
    }
  }
</style>
